/**
 * Filters Store
 *
 * Manages list filtering, sorting, and pagination state
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
const initialState = {
    investmentFilters: {},
    sort: {
        field: 'created_at',
        order: 'desc',
    },
    pagination: {
        page: 1,
        pageSize: 20,
        total: 0,
    },
    viewMode: 'table',
    density: 'normal',
};
export const useFiltersStore = create()(persist((set, get) => ({
    ...initialState,
    // Filter actions
    setFilter: (key, value) => set((state) => ({
        investmentFilters: {
            ...state.investmentFilters,
            [key]: value,
        },
        pagination: {
            ...state.pagination,
            page: 1, // Reset to first page when filter changes
        },
    })),
    setFilters: (filters) => set({
        investmentFilters: filters,
        pagination: {
            ...get().pagination,
            page: 1,
        },
    }),
    clearFilters: () => set({
        investmentFilters: {},
        pagination: {
            ...get().pagination,
            page: 1,
        },
    }),
    resetFilters: () => set({
        investmentFilters: initialState.investmentFilters,
    }),
    // Sort actions
    setSort: (field, order) => {
        const currentSort = get().sort;
        const newOrder = order || (currentSort.field === field && currentSort.order === 'asc' ? 'desc' : 'asc');
        set({
            sort: { field, order: newOrder },
            pagination: {
                ...get().pagination,
                page: 1,
            },
        });
    },
    toggleSortOrder: () => set((state) => ({
        sort: {
            ...state.sort,
            order: state.sort.order === 'asc' ? 'desc' : 'asc',
        },
    })),
    resetSort: () => set({
        sort: initialState.sort,
    }),
    // Pagination actions
    setPage: (page) => set((state) => ({
        pagination: {
            ...state.pagination,
            page,
        },
    })),
    setPageSize: (pageSize) => set((state) => ({
        pagination: {
            ...state.pagination,
            pageSize,
            page: 1, // Reset to first page when page size changes
        },
    })),
    setTotal: (total) => set((state) => ({
        pagination: {
            ...state.pagination,
            total,
        },
    })),
    nextPage: () => set((state) => {
        const { page, pageSize, total } = state.pagination;
        const maxPage = Math.ceil(total / pageSize);
        return {
            pagination: {
                ...state.pagination,
                page: Math.min(page + 1, maxPage),
            },
        };
    }),
    previousPage: () => set((state) => ({
        pagination: {
            ...state.pagination,
            page: Math.max(state.pagination.page - 1, 1),
        },
    })),
    resetPagination: () => set({
        pagination: initialState.pagination,
    }),
    // View actions
    setViewMode: (mode) => set({ viewMode: mode }),
    setDensity: (density) => set({ density }),
    // Reset
    reset: () => set(initialState),
}), {
    name: 'medsuite-filters-store',
    partialize: (state) => ({
        // Persist view preferences and last used filters
        viewMode: state.viewMode,
        density: state.density,
        sort: state.sort,
        pagination: {
            ...state.pagination,
            page: 1, // Always start at page 1 on reload
            total: 0, // Reset total on reload
        },
    }),
}));
//# sourceMappingURL=filters.store.js.map